import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * WizardProgress — Phase 43
 * Compact stepper with a text label and a progress bar. Mobile-first:
 * on small screens only shows "Step X di N" + bar; on desktop expands
 * with the current step title.
 */
const WizardProgress = ({ current, total, title }) => {
  const { t } = useTranslation('onboarding');
  const pct = Math.min(100, Math.max(0, (current / total) * 100));
  return (
    <div className="mb-6" data-testid="wizard-progress">
      <div className="mb-2 flex items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          {t('progress.step_of', { current, total })}
        </p>
        {title && (
          <p className="hidden text-xs text-muted-foreground md:block" data-testid="wizard-step-title">
            {title}
          </p>
        )}
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/[0.06]">
        <div
          className="h-full rounded-full gold-gradient transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

export default WizardProgress;
